<div class="fixed inset-0 bg-black/30 flex items-center justify-center z-[9999] animate-fade-in">
    <div class="bg-white text-gray-900  rounded-2xl shadow-2xl p-8 w-[90%] max-w-lg">
        <p class="text-[24px] font-bold mb-5">
            {{'newVersionOfAppAvailable' | translate}}
        </p>
        <div class="flex w-full">
            <button (click)="reload()"
                    mat-flat-button color="primary" class="px-6 py-2 w-full">
                {{'reload' | translate}}
            </button>
        </div>
    </div>
</div>
